var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4419 4.55806C10.686 4.80214 10.686 5.19786 10.4419 5.44194L6.50888 9.375H15.4167C15.7618 9.375 16.0417 9.65482 16.0417 10C16.0417 10.3452 15.7618 10.625 15.4167 10.625H6.50888L10.4419 14.5581C10.686 14.8021 10.686 15.1979 10.4419 15.4419C10.1979 15.686 9.80214 15.686 9.55806 15.4419L4.55806 10.4419C4.31398 10.1979 4.31398 9.80214 4.55806 9.55806L9.55806 4.55806C9.80214 4.31398 10.1979 4.31398 10.4419 4.55806Z",
    fill: "#656579"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow_back.7e59f8b3e289bbf7427120fa3ec7b9d4.svg";
export { ForwardRef as ReactComponent };